<template>
  <v-dialog v-model="dialog" :max-width="modalWidth">
    <v-btn slot="activator" flat outline color="primary"
      ><v-icon small>add</v-icon><slot>Invite Member</slot></v-btn
    >
    <v-card class="rounded-card elevation-6 pa-3">
      <v-toolbar dark color="primary lighten-2">
        <v-toolbar-title>Invite a Member to your team</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-alert
          v-if="error"
          :value="true"
          type="error"
          icon="warning"
          class="mb-4"
        >
          {{ errorMessage }}
        </v-alert>
        <v-form
          ref="form"
          v-model="valid"
          class="px-3"
          lazy-validation
          @submit.prevent
        >
          <v-text-field
            v-model="email"
            prepend-icon="email"
            name="email"
            label="Email Address"
            type="text"
            :rules="emailRules"
            hint="Enter the email address of the person you'd like to invite"
            persistent-hint
            required
            class="my-1"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="mt-2 grey lighten-5 rounded-card">
        <v-spacer></v-spacer>
        <v-btn flat round text color="primary" @click="dialog = false">
          <span>Cancel</span>
        </v-btn>
        <v-btn
          :disabled="!valid"
          type="submit"
          round
          class="accent"
          :loading="loading"
          @click="submit"
        >
          <v-icon small left>send</v-icon>
          Send Invite
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
const MODAL_WIDTH = '600px';

export default {
  data: function() {
    return {
      valid: false,
      error: false,
      errorMessage: 'Error.',
      email: null,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'E-mail must be valid'
      ],
      loading: false,
      dialog: false,
      modalWidth: MODAL_WIDTH
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    dialog: function(visible, hidden) {
      if (visible) {
        this.modalWidth =
          window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
        this.email = null;
        this.error = false;
        this.errorMessage = null;
        this.loading = false;
        this.$refs.form.resetValidation();
      }
    }
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.error = false;
        this.loading = true;
        const result = await this.sendInvitation(this.email);
        // eslint-disable-next-line
        // console.log('result -->', result);
        this.loading = false;
        if (result && result.success) {
          this.setSnack('Invitation sent!');
          this.dialog = false;
          this.email = null;
          this.error = false;
          this.errorMessage = null;
          this.$refs.form.resetValidation();
        } else {
          this.errorMessage = result.message;
          this.error = true;
        }
      }
    },
    ...mapActions({
      sendInvitation: 'account/sendInvitation',
      setSnack: 'snackbar/setSnack'
    })
  }
};
</script>
<style>
.rounded-card {
  border-radius: 10px;
}
</style>
